import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-components-specialist-actioncomponents-information',
	templateUrl: './information.component.html'
})
export class InformationComponent {
  @Input() customer: Boo.Objects.Customer;
  @Input() parentTaskId?: number;
}